export class BankData {
  public card_number:any;
  public exp_date:any;
  public cryptogramme:any;
  public card_username:any;
  public order_id:number;
  constructor() {

  }
}
